/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { map, tap } from 'rxjs/operators';
import { genericError } from 'src/app/models/placeholder';
import { AirportListService } from 'src/app/services/airport/airport-list.service';
import { EventService } from 'src/app/services/events/event.service';
import { HelperService } from 'src/app/services/helper/helper.service';
import { UiService } from 'src/app/services/ui.service';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { AirportListComponent } from '../../airport/airport-list/airport-list.component';
@Component({
  selector: 'flight-arrival',
  templateUrl: './flight-arrival.component.html',
  styleUrls: ['./flight-arrival.component.scss'],
})
export class FlightArrivalComponent implements OnInit {
  @Output() arrvDataArrived = new EventEmitter<boolean>();
  @Output() handleHeaderLoader = new EventEmitter<boolean>();
  public flights: any[];
  public page: number;
  public airport: string;
  public airportInfo = {};
  public noFlights = false;
  public image: string;
  constructor(
    private eventService: EventService,
    private airportListservice: AirportListService,
    private helperService: HelperService,
    private navControl: NavController,
    private uiService: UiService,
    private translate: TranslateService,
    private analyticsService: AnalyticsService,
    private modalController: ModalController
  ) {
    this.image = genericError;
  }

  ngOnInit() {
    this.page = 1;
    this.airport = this.airportListservice.getSelectedAirport();
    if (this.airport) {
      this.populateData();
    } else {
      this.handleHeaderLoader.emit(false);
    }
  }

  async populateData() {
    this.fetchFlights();
  }

  async fetchFlights() {
    // const loaderInstance = await this.uiService.presentGlobalLoading();
    // this.isLoading = true;
    this.handleHeaderLoader.emit(true);
    this.eventService
      .getFlights(this.airport, 1, this.page)
      .pipe(
        map((response: any) => {
          this.airportInfo = response?.airport?.airportData;
          return response?.flights?.map((item) => ({
            id: item.id,
            col1_data1: item?.airline_details?.airline_logo,
            col1_data2: item?.flight_id,
            col2_data1: item?.origin,
            col2_data2: item?.arrival_terminal
              ? this.translate.instant(
                  'trips.search_flights.flight_arrival.terminal'
                ) +
                '- ' +
                item?.arrival_terminal
              : '',
            col3_data1: item?.scheduled_arrival_time,
            col4: item?.status,
            flight_id: item?.flight_id,
            origin: item?.origin,
            dest: item?.dest,
            scheduled_departure: item?.scheduled_departure,
          }));
        })
      )
      .subscribe(
        (mappedItems) => {
          this.flights = mappedItems;
          if (this.flights == null || this.flights?.length === 0) {
            this.noFlights = true;
          }
          this.arrvDataArrived.emit(true);
          this.handleHeaderLoader.emit(false);
          // loaderInstance.dismiss();
        },
        (err) => {
          this.analyticsService.trackResponseError(err, 'Flight Home Error');
          console.log('error, ', err);
          this.handleHeaderLoader.emit(false);
        }
      );
  }

  navigateToDetail(flight: any) {
    let legNo = this.helperService.generateLegNo(
      flight.flight_id,
      flight.scheduled_departure,
      flight.origin,
      flight.dest
    );
    this.navControl.navigateForward(['flight/', legNo]);
    this.analyticsService.trackUnified('flight_arrival_clicked', {
      flow: 'flight',
      outcome: 'success',
      legacy_event_name: 'flight_arrival_clicked',
      component: 'flight-arrival-component',
      button: 'flight-arrival-card',
    });
  }

  getNextPage(event) {
    this.page++;
    // this.populateData();
    this.eventService
      .getFlights(this.airport, 1, this.page)
      .pipe(
        map((response: any) => {
          const data: any = [];
          data.totalCount = response?.totalCount;
          if (response?.flights?.length > 0) {
            data.flights = response?.flights?.map((item) => ({
              id: item.id,
              col1_data1: item?.airline_details?.airline_logo,
              col1_data2: item?.flight_id,
              col2_data1: item?.origin,
              // eslint-disable-next-line max-len
              col2_data2: item?.arrival_terminal
                ? this.translate.instant(
                    'trips.search_flights.flight_arrival.terminal'
                  ) +
                  '- ' +
                  item?.arrival_terminal
                : '',
              col3_data1: item?.scheduled_arrival_time,
              col4: item?.status,
              totalCount: response?.totalCount,
              flight_id: item?.flight_id,
              origin: item?.origin,
              dest: item?.dest,
              scheduled_departure: item?.scheduled_departure,
            }));
          }
          return data;
        })
      )
      .subscribe({
        next: (response) => {
          let totalCount = response.totalCount;
          if (response.flights) {
            this.flights = this.flights.concat(response.flights);
          }
          event.target.complete();
          if (this.flights.length === totalCount) {
            event.target.disabled = true;
          } else {
            event.target.disabled = false;
          }
        },
        error: (err: any) => {
          this.analyticsService.trackResponseError(err, 'Flight Arrival Error');
          console.log(err);
        },
        complete: () => {
          // loader.dismiss();
        },
      });
  }
  reloadCurrentRoute() {
    window.location.reload();
  }

  async presentModal() {
    this.analyticsService.trackUnified('airport_select_modal_opened', {
      flow: 'flight',
      outcome: 'success',
      legacy_event_name: 'button_clicked',
      component: 'airport-list-component',
      button: 'select-airport-button',
    });

    const modal = await this.modalController.create({
      component: AirportListComponent,
      componentProps: {
        type: '',
      },
      backdropDismiss: false,
    });
    modal.onDidDismiss().then(async (data) => {
      if (data.data) {
        this.analyticsService.trackUnified('airport_selected', {
          flow: 'flight',
          outcome: 'success',
          legacy_event_name: 'selected_airport',
          component: 'airport-list-component',
          button: 'select-airport-button',
          airport: data.data.airport.airportCode,
        });
        this.airport = data.data.airport.airportCode;
        this.airportInfo = data.data.airport;
        this.fetchFlights();
        this.analyticsService.trackUnified('airport_select_modal_confirmed', {
          flow: 'flight',
          outcome: 'success',
          legacy_event_name: 'button_clicked',
          component: 'airport-list-component',
          button: 'select-airport-button',
          airport: data.data.airport.airportCode,
        });
      }
    });
    return await modal.present();
  }
}
